





import Vue from "vue";
import {Component} from "vue-property-decorator";
@Component({
    components: {},
    props: {}
})

export default class FpsCounter extends Vue {
    private fps: number = 0;
    private times: Array<number> = [];

    mounted(): void
    {
        this.refreshLoop();
    }

    private refreshLoop() {
        window.requestAnimationFrame(() => {
            const now = performance.now();
            while (this.times.length > 0 && this.times[0] <= now - 1000) {
                this.times.shift();
            }
            this.times.push(now);
            this.fps = this.times.length;
            this.refreshLoop();
        });
    }
}
